<template>
  <MainLayout>
    <ReservationChange />
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import ReservationChange from '@/components/reserve/ReservationChange.vue';

export default {
  name: 'ReservationChangeView',
  components: {
    MainLayout,
    ReservationChange,
  },
};
</script>
